import { render, staticRenderFns } from "./reason-dialog.vue?vue&type=template&id=9ed99ce4&scoped=true"
import script from "./reason-dialog.vue?vue&type=script&lang=js"
export * from "./reason-dialog.vue?vue&type=script&lang=js"
import style0 from "./reason-dialog.vue?vue&type=style&index=0&id=9ed99ce4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ed99ce4",
  null
  
)

export default component.exports